import {
  gasTankGetGasTankList,
  gasTankAddGasTank,
  gasTankUpdateGasTank,
  gasTankDeleteGasTank,
  gasTankUpdateGasTankStatus,
  gasTankMergeGasTank
} from '@/api/api'

const state = {
  gasTankGasInfo: null,
  gasTankList: []
}

const getters = {
  gasTankList: state => state.gasTankList,
  gasTankGasInfo: state => state.gasTankGasInfo
}

const actions = {
  setGasTankList ({ commit }, data) {
    commit('setGasTankList', data)
  },
  setGasTankGasInfo ({ commit }, data) {
    commit('setGasTankGasInfo', data)
  },
  loadGasTankList ({ dispatch }, parm) {
    return gasTankGetGasTankList(parm).then((data) => {
      data.list.forEach((item) => {
        item['isMergeText'] = item['isMerge'] ? '虚拟' : '--'
        item['statusText'] = item['status'] === 'open' ? '开启' : '关闭'
      })
      dispatch('setGasTankList', data.list)
    })
  },
  addGasTank ({ commit }, parm) {
    return gasTankAddGasTank(parm)
  },
  gasTankMergeGasTank ({ commit }, parm) {
    return gasTankMergeGasTank(parm)
  },
  gasTankUpdateGasTankStatus ({ commit }, parm) {
    return gasTankUpdateGasTankStatus(parm)
  },
  updateGasTank ({ commit }, parm) {
    return gasTankUpdateGasTank(parm)
  },
  delGasTank ({ commit }, gasId) {
    return gasTankDeleteGasTank(gasId)
  }
}

const mutations = {
  setGasTankList (state, data) {
    state.gasTankList = data
  },
  setGasTankGasInfo (state, data) {
    state.gasTankGasInfo = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/base_data/gas_tank.js